<div class="{{buttonAlignmentClass}} rowIcons" [hidden]="actionButtons.length === 0">
    <a style="padding: 0px 5px;" #actionLink *ngFor="let item of actionButtons; let i = index"
        [ngClass]="{'disabled': item.isDisabled, 'greyed-out': item.isGreyedOut && !item.isDisabled }"
        [hidden]="item.isHidden" tabindex="0" role="button" [attr.aria-label]="item.buttonTooltip || item.userAction"
        [attr.aria-disabled]="item.isDisabled"
        (click)="!item.isDisabled && onUserAction(item.userAction);"
        (keydown)="onActionKeyDown($event, i)">
        <ion-spinner *ngIf="item.isLoading" name="crescent" [ngClass]="item.buttonClass" [attr.aria-label]="item.buttonTooltip"></ion-spinner>
        <ion-icon *ngIf="!item.isLoading && item.iconName" [name]="item.iconName" [ngClass]="item.buttonClass"
            [tooltip]="item.isDisabled ? (item.resolvedDisabledTooltip || item.buttonTooltip) : item.buttonTooltip"
            placement="left"></ion-icon>
        <ion-icon *ngIf="!item.isLoading && !item.iconName" [src]="item.url" [ngClass]="item.buttonClass"
            [tooltip]="item.isDisabled ? (item.resolvedDisabledTooltip || item.buttonTooltip) : item.buttonTooltip"
            placement="left"></ion-icon>
    </a>
</div>